import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limitTo' })
export class LimitToPipe implements PipeTransform {
  transform(value: any, limit: number): any {
    if (!value) {
      return value;
    }
    return value.slice(0, limit);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/limit-to.pipe.ts